import type { SlotReadyEvent } from "../events/SlotReadyEvent";
import { format } from "date-fns";
import { getCountdownText } from "./countdown";
import { de } from "date-fns/locale";
import type { DetailviewBenefit } from "./DetailviewBenefit";
import { eventQBus } from "@otto-ec/global-resources/event-q-bus";

export function buildDetailviewBenefitScarcity(partnerDiscount: DetailviewBenefit, event: SlotReadyEvent) {
	const scarcitySpanId = `benefit-detailview_partnerbenefit-scarcity_${partnerDiscount.id}_${event.variationId}`;
	const scarcityLine = getBenefitDetailviewScarcityLine(partnerDiscount, event, scarcitySpanId);
	return scarcityLine.trim() ? `<div id="${scarcitySpanId}" class="benefit-detailview_partnerbenefit-scarcity">${scarcityLine}</div>` : "";
}

function getBenefitDetailviewScarcityLine(discount: DetailviewBenefit, event: SlotReadyEvent, scarcitySpanId: string): string {
	const setAndGetCountdownText = () => {
		const targetElement = event.targetElement;

		const expirationCallback = () => {
			/*         */
			window.clearInterval(targetElement);
			eventQBus.emit("ft9.benefit.expired", {
				benefit: discount,
				targetElement: targetElement,
				variationId: event.variationId,
			});
		};

		const text = getCountdownText(discount.activeUntil, expirationCallback);

		const scarcitySpan = targetElement.querySelector(`#${scarcitySpanId}`);
		if (scarcitySpan && text.length > 0) {
			scarcitySpan.textContent = text;
		}

		return text;
	};

	switch (discount.scarcityValue) {
		/*        */
		case 0: {
			return "";
		}
		/*   */
		case 1: {
			/*               */
			event.targetElement.interval = window.setInterval(() => {
				setAndGetCountdownText();
			}, 1_000);

			return setAndGetCountdownText();
		}
		/*      */
		case 2: {
			/*               */
			event.targetElement.interval = window.setInterval(() => {
				setAndGetCountdownText();
			}, 60_000);

			setAndGetCountdownText();
			return format(discount.activeUntil, `'nur bis morgen, 'HH:mm' Uhr'`, { locale: de });
		}
		/*          */
		case 3: {
			return format(discount.activeUntil, `'nur bis 'eeeeee, dd.MM.`, { locale: de });
		}
		default: {
			return "";
		}
	}
}
